export default '/build/d0f3943f.svg'